import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import keterlambatanProyekService from "../../services/keterlambatanProyekService";

export const initialState = {
    loading_keterlambatan_proyek: false,
    data_keterlambatan_proyek: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataKeterlambatanProyek = createAsyncThunk('keterlambatan_proyek/data',async (data, { rejectWithValue }) => {
    try {
        const response = await keterlambatanProyekService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const keterlambatanProyekSlice = createSlice({
    name: 'keterlambatan_proyek',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_keterlambatan_proyek = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKeterlambatanProyek.fulfilled, (state, action) => {
                state.loading_keterlambatan_proyek = false
                state.data_keterlambatan_proyek = action.payload??[]
            })
            .addCase(getDataKeterlambatanProyek.pending, (state) => {
                state.loading_keterlambatan_proyek = true
            })
            .addCase(getDataKeterlambatanProyek.rejected, (state, action) => {
                state.loading_keterlambatan_proyek = false
                state.data_keterlambatan_proyek = action.payload
            })

    },
})

export const {
    showLoading,
} = keterlambatanProyekSlice.actions

export default keterlambatanProyekSlice.reducer
